import { render } from "./DaysOff.vue?vue&type=template&id=1a8987c9&scoped=true"
import script from "./DaysOff.vue?vue&type=script&lang=js"
export * from "./DaysOff.vue?vue&type=script&lang=js"

import "./DaysOff.vue?vue&type=style&index=0&id=1a8987c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8987c9"]])

export default __exports__